import { usePaginatedQuery } from '@hooks/usePaginatedQuery';
import { useAuth } from '@contexts/AuthContext';
import { useProId } from '@contexts/ProIdContext';
import { GET_JOB_OFFER_TEMPLATES, GET_JOB_OFFER_TEMPLATES_UPERCUT } from '@gql/jobOfferTemplates';

export const useGetJobOfferTemplates = (
    query: string = '',
    filter: any = {},
    sortBy: string = 'createdDate',
    page: number = 0,
    pageSize: number = 12,
) => {
    const { user, isUpercut } = useAuth();
    const { isProIdRequired } = useProId();

    const isUpercutMode = isUpercut && !isProIdRequired;
    const queryToUse = isUpercutMode ? GET_JOB_OFFER_TEMPLATES_UPERCUT : GET_JOB_OFFER_TEMPLATES;

    const { rows, totalDocs, loading, isLoadingMore, hasMore, loadMore, error, refetch } = usePaginatedQuery({
        query: queryToUse,
        variables: { query, filter, sortBy },
        page,
        pageSize,
        baseLimit: 12,
        paginationMode: 'offset',
        skip: !user,
        extractResult: (data) => {
            const templatesData = isUpercutMode
                ? data?.getJobOfferTemplatesUpercut
                : data?.getJobOfferTemplatesPro;
            return {
                docs: templatesData?.docs ?? [],
                meta: templatesData?.meta ?? { totalDocs: 0, page: 0, limit: pageSize, totalPages: 0, nextPage: null, prevPage: null },
                totalDocs: templatesData?.meta?.totalDocs ?? 0,
            };
        },
    });

    return {
        templates: rows,
        totalDocs,
        totalPages: Math.ceil(totalDocs / pageSize),
        loading,
        isLoadingMore,
        hasMore,
        loadMore,
        error,
        refetch,
        userRole: user?.role,
    };
};
